import { render, staticRenderFns } from "./LoginFormByPassword.vue?vue&type=template&id=954266b2&scoped=true&"
import script from "./LoginFormByPassword.vue?vue&type=script&lang=js&"
export * from "./LoginFormByPassword.vue?vue&type=script&lang=js&"
import style0 from "./LoginFormByPassword.vue?vue&type=style&index=0&id=954266b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954266b2",
  null
  
)

export default component.exports